import { render, staticRenderFns } from "./popup-content.mpx?vue&type=template&id=9452d3de&isComponent&outputPath=components%2Fpopup-contentc0bc60c0%2Findex"
import script from "./popup-content.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fpopup-contentc0bc60c0%2Findex"
export * from "./popup-content.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fpopup-contentc0bc60c0%2Findex"
import style0 from "./popup-content.mpx?vue&type=style&index=0&id=9452d3de&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_c0bc60c0%22%7D&isComponent&outputPath=components%2Fpopup-contentc0bc60c0%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports